import { observer } from 'mobx-react-lite';
import { FONT_COLOR } from '../../../../../components/fonts/font-props';
import FontBody2 from '../../../../../components/fonts/font-body2/font-body2';
import Divider from '../../../../subscription-plans/components/plan-info/divider/divider';

import { IRefundCalculatorResponseDto } from '../refund-calculator-types';

import { CalculatorHeader, CalculatorBreakdown, CalculatorTotals } from './components';
import './refund-calculator-display.scss';

interface RefundCalculatorDisplayProps {
    data: IRefundCalculatorResponseDto;
}

const RefundCalculatorDisplay: React.FC<RefundCalculatorDisplayProps> = observer(({ data }) => {
    if (!data.original_items || !data.original_items.items || data.original_items.items.length === 0) {
        return (
            <div className="refund-calculator-display">
                <FontBody2 color={FONT_COLOR.SEMANTIC_DANGER}>
                    Invalid refund calculation data: missing original items
                </FontBody2>
            </div>
        );
    }

    if (!data.original_items.total_amount) {
        return (
            <div className="refund-calculator-display">
                <FontBody2 color={FONT_COLOR.SEMANTIC_DANGER}>
                    Invalid refund calculation data: missing original items total amount
                </FontBody2>
            </div>
        );
    }

    const handleCopyJson = async () => {
        try {
            await navigator.clipboard.writeText(JSON.stringify(data, null, 2));
        } catch (error) {
            console.error('Failed to copy JSON:', error);
        }
    }

    return (
        <div className="refund-calculator-display">
            <div className="refund-calculator-display__main-card">
                <CalculatorHeader data={data} onCopyJson={handleCopyJson} />
                <div className="refund-calculator-display__content">
                    <CalculatorBreakdown data={data} />
                    <Divider marginTop="10px" marginBottom="10px"/>
                    <CalculatorTotals subtotal={data.subtotal_price} total={data.total_price} />
                </div>
            </div>
        </div>
    );
});

export default RefundCalculatorDisplay;
